import { render, staticRenderFns } from "./ImportContact.vue?vue&type=template&id=7e4474ec&"
import script from "./ImportContact.vue?vue&type=script&lang=js&"
export * from "./ImportContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports